import {
  MemberShipTier,
  RightsCode,
  SubscriptionPlan,
  ThirdPayment,
  ThirdPaymentEnum,
} from '@/types/subscribe'
import { i18nKey } from '@/lib/i18n-key'
import { ReactNode } from 'react'

// TODO: 测试环境和线上环境分别配置
export const SubscribeStarLink = 'https://riotmodels.com/tipsy-chat'
export const PatreonLink = 'https://www.patreon.com/paliacci'
export const PatreonUnsubscribeLink =
  'https://www.patreon.com/settings/memberships'
export const SubscribeStarUnsubscribeLink =
  'https://riotmodels.com/subscriptions'
export const URL_SUBSCRIBE = '/billing/plans'
export const URL_SUBSCRIBE_SUCCESS = '/balance'

export const SubscriptionPeriods = [
  i18nKey('Yearly'),
  i18nKey('Monthly'),
] as const

export const MemberShipTierName = {
  [MemberShipTier.Free]: i18nKey('Free'),
  [MemberShipTier.OnTrial]: i18nKey('On Trial'),
  [MemberShipTier.GetATaste]: i18nKey('Get a Taste'),
  [MemberShipTier.Standard]: i18nKey('Standard'),
  [MemberShipTier.Premium]: i18nKey('Premium'),
  [MemberShipTier.Deluxe]: i18nKey('Deluxe'),
} as const

export const MemberShipRightsName = {
  [RightsCode.Message]: 'Message',
  [RightsCode.Model]: 'Model',
  [RightsCode.Gems]: 'Gems',
  [RightsCode.ExtraGems]: 'ExtraGems',
} as const

export const SubscribePlans: SubscriptionPlan[] = [
  {
    tier: MemberShipTier.Free,
    bg: '/payment/subscribe_card_icon_bg_0.svg',
    iconGem: '/payment/subscribe_card_icon_gems_0.svg',
    blueGemDesc: i18nKey('No Free Gems'),
    blueGemDescNew: i18nKey('No Free Gems'),
    messageDesc: '',
    memoryDesc: i18nKey('Up to 1M of Memory'),
    createDesc: i18nKey('Create Custom Characters'),
    modelDesc: '',
    inspirationDesc: 'Inspirations',
    gemsRecharge: i18nKey('Gems Recharge'),
    newFeatureDesc: i18nKey('New Feature Access'),
    roleCardDesc: i18nKey('Up to 3 Role Cards'),

    freeBlueGems: [i18nKey('No Free Gems'), 'locked'],
    roleCards: [i18nKey('Up to 3 Role Cards'), 'yes'],
    inspirations: [i18nKey('3 Inspirations'), 'yes'],
    pinnedMemory: [i18nKey('Pinned Memory'), 'locked'],
    downloadAndSaveChats: [i18nKey('Download and save chats'), 'locked'],
    withoutWatermark: [i18nKey('Download Without Watermark'), 'locked'],
    memory: [i18nKey('Up to 2M of memory'), 'yes'],
    createCustomCharacters: [i18nKey('Create Custom Characters'), 'yes'],
    priorityImage: [i18nKey('Priority Image Generation'), 'locked'],
    gemRecharge: [i18nKey('Gems Recharge'), 'yes'],
    newFeature: [i18nKey('New Feature Access'), 'locked'],
  },
  {
    tier: MemberShipTier.GetATaste,
    bg: '/payment/subscribe_card_icon_bg_01.svg',
    iconGem: '/payment/subscribe_card_icon_gems_01.png',
    blueGemDesc: i18nKey('Free 2,000 Blue Gems/month'),
    blueGemDescNew: i18nKey('Free 1,200 Blue Gems/month'),
    messageDesc: '',
    memoryDesc: i18nKey('Up to 1M of Memory'),
    createDesc: i18nKey('Create Custom Characters'),
    modelDesc: '',
    inspirationDesc: 'Inspirations',
    priorityImgGen: i18nKey('Priority Image Generation'),
    gemsRecharge: i18nKey('Gems Recharge'),
    newFeatureDesc: i18nKey('New Feature Access'),
    roleCardDesc: i18nKey('Up to 10 Role Cards'),

    bonusDesc: [
      i18nKey('+100 Gems'),
      i18nKey('New User Only'),
      i18nKey('+100 Gems (New User Only)'),
    ],
    bonusDescYearly: [
      i18nKey('+500 Gems'),
      i18nKey('New User Only'),
      i18nKey('+500 Gems (New User Only)'),
    ],
    bonusDescThanks: [
      i18nKey('+100 Gems'),
      i18nKey('Limited Time Offer'),
      '+100 Gems (Limited Time Offer)',
    ],
    bonusDescJanuaryAnnual: [
      i18nKey('+1200 Gems'),
      i18nKey('Limited Time Offer'),
    ],
    freeBlueGems: [i18nKey('Free 1,200 Blue Gems/month'), 'update'],
    roleCards: [i18nKey('Up to 10 Role Cards'), 'update'],
    inspirations: [i18nKey('3 Inspirations'), 'yes'],
    pinnedMemory: [i18nKey('Pinned Memory'), 'locked'],
    downloadAndSaveChats: [i18nKey('Download and save chats'), 'locked'],
    withoutWatermark: [i18nKey('Download Without Watermark'), 'locked'],
    memory: [i18nKey('Up to 2M of memory'), 'yes'],
    createCustomCharacters: [i18nKey('Create Custom Characters'), 'yes'],
    priorityImage: [i18nKey('Priority Image Generation'), 'update'],
    gemRecharge: [i18nKey('Gems Recharge'), 'yes'],
    newFeature: [i18nKey('New Feature Access'), 'locked'],
  },
  {
    tier: MemberShipTier.Standard,
    bg: '/payment/subscribe_card_icon_bg_02.svg',
    iconGem: '/payment/subscribe_card_icon_gems_02.png',
    blueGemDesc: i18nKey('Free 6,000 Blue Gems/month'),
    blueGemDescNew: i18nKey('Free 4,000 Blue Gems/month'),
    messageDesc: '',
    memoryDesc: i18nKey('Up to 1M of Memory'),
    createDesc: i18nKey('Create Custom Characters'),
    modelDesc: '',
    inspirationDesc: i18nKey('Unlimited Inspirations'),
    priorityImgGen: i18nKey('Priority Image Generation'),
    gemsRecharge: i18nKey('Gems Recharge'),
    newFeatureDesc: i18nKey('New Feature Access'),
    roleCardDesc: i18nKey('Up to 20 Role Cards'),
    withoutWatermarkDesc: i18nKey('Download Without Watermark'),

    //gift: ['+1000 Gems', 'Limited Time Offer'],
    bonusDesc: [
      i18nKey('+400 Gems'),
      i18nKey('New User Only'),
      i18nKey('+400 Gems (New User Only)'),
    ],
    bonusDescYearly: [
      i18nKey('+2500 Gems'),
      i18nKey('New User Only'),
      i18nKey('+2500 Gems (New User Only)'),
    ],
    bonusDescThanks: [
      i18nKey('+500 Gems'),
      i18nKey('Limited Time Offer'),
      '+500 Gems (Limited Time Offer)',
    ],
    bonusDescJanuaryAnnual: [
      i18nKey('+6000 Gems'),
      i18nKey('Limited Time Offer'),
    ],
    freeBlueGems: [i18nKey('Free 4,000 Blue Gems/month'), 'update'],
    roleCards: [i18nKey('Up to 20 Role Cards'), 'update'],
    inspirations: [i18nKey('Unlimited Inspirations'), 'update'],
    pinnedMemory: [i18nKey('2k Pinned Memory'), 'update'],
    downloadAndSaveChats: [i18nKey('Download and save chats'), 'locked'],
    withoutWatermark: [i18nKey('Download Without Watermark'), 'update'],
    memory: [i18nKey('Up to 2M of memory'), 'yes'],
    createCustomCharacters: [i18nKey('Create Custom Characters'), 'yes'],
    priorityImage: [i18nKey('Priority Image Generation'), 'yes'],
    gemRecharge: [i18nKey('Gems Recharge'), 'yes'],
    newFeature: [i18nKey('New Feature Access'), 'locked'],
  },
  {
    tier: MemberShipTier.Premium,
    bg: '/payment/subscribe_card_icon_bg_03.svg',
    iconGem: '/payment/subscribe_card_icon_gems_03.png',
    blueGemDesc: i18nKey('Free 20,000 Blue Gems/month'),
    blueGemDescNew: i18nKey('Free 15,000 Blue Gems/month'),
    messageDesc: i18nKey('Unlimited Messaging on Specific Models'),
    memoryDesc: i18nKey('Up to 1M of Memory'),
    createDesc: i18nKey('Create Custom Characters'),
    modelDesc: '',
    inspirationDesc: i18nKey('Unlimited Inspirations'),
    priorityImgGen: i18nKey('Priority Image Generation'),
    gemsRecharge: i18nKey('Gems Recharge'),
    newFeatureDesc: i18nKey('New Feature Access'),
    roleCardDesc: i18nKey('Unlimited Role Cards'),
    downloadChatDesc: i18nKey('Download and save chats'),
    withoutWatermarkDesc: i18nKey('Download Without Watermark'),

    //gift: ['+1500 Gems', 'Limited Time Offer'],
    bonusDesc: [
      i18nKey('+1200 Gems'),
      i18nKey('New User Only'),
      i18nKey('+1200 Gems (New User Only)'),
    ],
    bonusDescYearly: [
      i18nKey('+7500 Gems'),
      i18nKey('New User Only'),
      i18nKey('+7500 Gems (New User Only)'),
    ],
    bonusDescThanks: [
      '+2000 Gems',
      i18nKey('Limited Time Offer'),
      '+2000 Gems (Limited Time Offer)',
    ],
    bonusDescJanuaryAnnual: [
      i18nKey('+25000 Gems'),
      i18nKey('Limited Time Offer'),
    ],
    freeBlueGems: [i18nKey('Free 15,000 Blue Gems/month'), 'update'],
    roleCards: [i18nKey('Unlimited Role Cards'), 'update'],
    inspirations: [i18nKey('Unlimited Inspirations'), 'yes'],
    pinnedMemory: [i18nKey('3k Pinned Memory'), 'update'],
    downloadAndSaveChats: [i18nKey('Download and save chats'), 'update'],
    withoutWatermark: [i18nKey('Download Without Watermark'), 'yes'],
    memory: [i18nKey('Up to 2M of memory'), 'yes'],
    createCustomCharacters: [i18nKey('Create Custom Characters'), 'yes'],
    priorityImage: [i18nKey('Priority Image Generation'), 'yes'],
    gemRecharge: [i18nKey('Gems Recharge'), 'yes'],
    newFeature: [i18nKey('New Feature Access'), 'update'],
  },
  {
    tier: MemberShipTier.Deluxe,
    bg: '/payment/subscribe_card_icon_bg_04.svg',
    iconGem: '/payment/subscribe_card_icon_gems_01.png',
    blueGemDesc: i18nKey('Free 40,000 Blue Gems/month'),
    blueGemDescNew: i18nKey('Free 30,000 Blue Gems/month'),
    messageDesc: i18nKey('Unlimited Messaging on Specific Models'),
    memoryDesc: i18nKey('Up to 1M of Memory'),
    createDesc: i18nKey('Create Custom Characters'),
    modelDesc: '',
    inspirationDesc: i18nKey('Unlimited Inspirations'),
    priorityImgGen: i18nKey('Priority Image Generation'),
    gemsRecharge: i18nKey('Gems Recharge'),
    newFeatureDesc: i18nKey('New Feature Access'),
    roleCardDesc: i18nKey('Unlimited Role Cards'),
    downloadChatDesc: i18nKey('Download and save chats'),
    withoutWatermarkDesc: i18nKey('Download Without Watermark'),

    //gift: ['+500 Gems', 'Limited Time Offer'],
    bonusDesc: [
      i18nKey('+2500 Gems'),
      i18nKey('New User Only'),
      i18nKey('+2500 Gems (New User Only)'),
    ],
    bonusDescYearly: [
      i18nKey('+16000 Gems'),
      i18nKey('New User Only'),
      i18nKey('+16000 Gems (New User Only)'),
    ],
    bonusDescThanks: [
      i18nKey('+4000 Gems'),
      i18nKey('Limited Time Offer'),
      i18nKey('+4000 Gems (Limited Time Offer)'),
    ],
    bonusDescJanuaryAnnual: [
      i18nKey('+50000 Gems'),
      i18nKey('Limited Time Offer'),
    ],
    freeBlueGems: [i18nKey('Free 30,000 Blue Gems/month'), 'update'],
    roleCards: [i18nKey('Unlimited Role Cards'), 'yes'],
    inspirations: [i18nKey('Unlimited Inspirations'), 'yes'],
    pinnedMemory: [i18nKey('4k Pinned Memory'), 'update'],
    downloadAndSaveChats: [i18nKey('Download and save chats'), 'yes'],
    withoutWatermark: [i18nKey('Download Without Watermark'), 'yes'],
    memory: [i18nKey('Up to 2M of memory'), 'yes'],
    createCustomCharacters: [i18nKey('Create Custom Characters'), 'yes'],
    priorityImage: [i18nKey('Priority Image Generation'), 'yes'],
    gemRecharge: [i18nKey('Gems Recharge'), 'yes'],
    newFeature: [i18nKey('New Feature Access'), 'yes'],
  },
  {
    tier: MemberShipTier.OnTrial,
    bg: '/payment/subscribe_card_icon_bg_0.svg',
    iconGem: '/payment/subscribe_card_icon_gems_0.svg',
    blueGemDesc: '',
    messageDesc: i18nKey('Unlimited Messaging'),
    inspirationDesc: i18nKey('Free Inspiration'),
    memoryDesc: i18nKey('Up to 1M of Memory'),
    createDesc: i18nKey('Create Custom Characters'),
    modelDesc: i18nKey('Base Model Only'),

    gift: ['', ''],
    freeBlueGems: ['', 'locked'],
    roleCards: ['', 'locked'],
    inspirations: ['', 'locked'],
    pinnedMemory: ['', 'locked'],
    downloadAndSaveChats: ['', 'locked'],
    withoutWatermark: ['', 'locked'],
    memory: ['', 'locked'],
    createCustomCharacters: ['', 'locked'],
    priorityImage: ['', 'locked'],
    gemRecharge: ['', 'locked'],
    newFeature: ['', 'locked'],
  },
]

export type UpgradeModalType =
  | 'message'
  | 'model'
  | 'msgLen'
  | 'memory8k'
  | 'memory16k'
  | 'memory32k'
  | 'memory64k'

export const UpgradeTitleMap: Record<UpgradeModalType, ReactNode> = {
  message: i18nKey('Message Limit Reached'),
  model: i18nKey('Access this feature'),
  msgLen: i18nKey('Want to use this function'),
  memory8k: i18nKey('Want to use this function'),
  memory16k: i18nKey('Want to use this function'),
  memory32k: i18nKey('Want to use this function'),
  memory64k: i18nKey('Want to use this function'),
}

export const UpgradeDescMap: Record<UpgradeModalType, ReactNode> = {
  message: i18nKey(
    "You've reached your message limit! Upgrade your subscription to keep chatting with the character"
  ),
  model: i18nKey(
    'This feature is exclusive to subscribers Click below to manage your subscription'
  ),
  msgLen: i18nKey(
    'Only Standard/Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.'
  ),
  memory8k: i18nKey(
    'Only Get a Taste/Standard/Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.'
  ),
  memory16k: i18nKey(
    'Only Standard/Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.'
  ),
  memory32k: i18nKey(
    'Only Premium/Deluxe subscription users can use. You can click the button to upgrade your subscription.'
  ),
  memory64k: i18nKey(
    'Only Deluxe subscription users can use. You can click the button to upgrade your subscription.'
  ),
}

export const PayWithCreditCardInfo = i18nKey(
  'Info: This payment method does NOT automatically renew and is only available for a one-time annual payment. Upgrades are possible within the same year, but downgrades are NOT allowed'
)
